export const transferCronexPressionToText = (a, isLog) => {
  let findall = (arr, x) => {
    let results = [];
    arr.forEach((el, i) => el.indexOf(x) != -1 && results.push(i));
    return results;
  };
  let statistics = (a, time) => {
    let results = [];
    if (a.length) {
      a.forEach((j, jndex) => {
        results.push(time[j]);
      });
    }
    return results;
  }
  if (!a) {
    return a;
  }
  if (a.split(' ').length === 6) {
    a = '00 ' + a;
  }
  let finalTitle = [];
  let lable = ['秒', '分', '时', '日', '月', '星期', '年'];
  let time = ['s', 'm', 'h', 'd', 'month', 'week', 'year'];
  // 每出现次数
  let everyCount = 0;
  // 周期出现次数
  let periodCount = 0;
  // 循环出现次数
  let loopCount = 0;
  let arr = a.split(' ');
  //多次出现*号将不为第一次出现的项变为未指定
  let mapArr = arr.map((item, index) => {
    if (item == '*' && index != arr.indexOf('*')) {
      return (item = '?');
    } else {
      return item;
    }
  });
  let loopLastindex = null;
  mapArr.forEach((item, index) => {
    if (item.indexOf('/') != -1) {
      loopLastindex = index;
    }
  });
  mapArr.forEach((item, index) => {
    let str = '';
    if (item.indexOf('-') != -1) {
      if (index == 5) {
        str = `${[lable[index]]}${item.split('-')[0]}至${[lable[index]]}${item.split('-')[1]}`;
      } else {
        str = `${item.split('-')[0]}至${item.split('-')[1]}${[lable[index]]}`;
      }
      periodCount++;
    } else if (item.indexOf('/') != -1) {
      if (index == 5) {
        if (index == loopLastindex) {
          str = `从${[lable[index]]}${item.split('/')[0]}开始，每${item.split('/')[1]}天`;
        } else {
          str = `${[lable[index]]}${item.split('/')[0]}，每${item.split('/')[1]}天`;
        }
      } else if (index == 2) {
        if (index == loopLastindex) {
          str = `从${item.split('/')[0]}${[lable[index]]}开始，每${item.split('/')[1]}小时`;
        } else {
          str = `${item.split('/')[0]}${[lable[index]]}，每${item.split('/')[1]}小时`;
        }
      } else if (index == 4) {
        if (index == loopLastindex) {
          str = `从${item.split('/')[0]}${[lable[index]]}开始，每${item.split('/')[1]}个月`;
        } else {
          str = `${item.split('/')[0]}${[lable[index]]}，每${item.split('/')[1]}个月`;
        }
      } else {
        if (index == loopLastindex) {
          str = `从${item.split('/')[0]}${[lable[index]]}开始，每${item.split('/')[1]}${[lable[index]]}`;
        } else {
          str = `${item.split('/')[0]}${[lable[index]]}，每${item.split('/')[1]}${[lable[index]]}`;
        }
      }
      loopCount++;
    } else if (item.indexOf('W') != -1) {
      str = `本月${item.split('W')[0]}${[lable[index]]},最近的工作日`;
    } else if (item.indexOf('L') != -1) {
      if (index == 5) {
        str = `本月最后一个${[lable[index]]}${item.split('L')[0]}`;
      } else {
        str = `本月最后一天`;
      }
    } else if (item.indexOf('#') != -1) {
      str = `本月第${item.split('#')[0]}周,星期${item.split('#')[1]}`;
    } else if (item.indexOf('*') != -1) {
      // str = `每${[lable[index]]}`;
      if (everyCount) {
        str = '';
      } else {
        str = `每${[lable[index]]}`;
        everyCount++;
      }
    } else if (item.indexOf(',') != -1) {
      if (index == 5) {
        str = `${[lable[index]]}${item}`;
      } else {
        str = `${item}${[lable[index]]}`;
      }
    } else if (item.indexOf('?') != -1 || index == 0) {
      str = ` `;
    } else if (typeof Number(item) === 'number' && !isNaN(Number(item))) {
      if (index == 5) {
        str = `${[lable[index]]}${Number(item)}`;
      } else {
        str = `${Number(item)}${[lable[index]]}`;
      }
    } else {
      str = '';
    }
    time[index] = str;
  });
  let newArr = arr;
  time.reverse()
  newArr.reverse();
  //周期
  let periodArr = findall(newArr, '-');
  // 循环
  let loopArr = findall(newArr, '/');
  // 指定周
  let specifyArr = findall(newArr, '#');
  // 工作日
  let workArr = findall(newArr, 'W');
  // 最后一个
  let lastArr = findall(newArr, 'L');
  // 每
  let everyArr = findall(newArr, '*');
  // 指定
  let appointArr = [];
  newArr.forEach((item, index) => {
    if ((typeof Number(item) === 'number' && !isNaN(Number(item)) && index !== newArr.length - 1) || item.indexOf(',') != -1) {
      appointArr.push(index);
    }
  });
  let periodStr = statistics(periodArr, time);
  let loopStr = statistics(loopArr, time);
  let specifyStr = statistics(specifyArr, time);
  let workStr = statistics(workArr, time);
  let lastStr = statistics(lastArr, time);
  let everyStr = statistics(everyArr, time);
  let appointStr = statistics(appointArr, time);
  if (everyStr.length) {
    finalTitle.push(isLog ? `${everyStr[everyStr.length - 1]}` : `触发频次：${everyStr[everyStr.length - 1]}执行一次`);
  }
  if (periodStr.length) {
    finalTitle.push(isLog ? `${periodStr.join('的')}` : `触发周期：${periodStr.join('的')}`);
  }
  if (loopStr.length) {
    finalTitle.push(isLog ? `${loopStr.join('的')}` : `触发循环：${loopStr.join('的')}执行一次`);
  }
  if (specifyStr.length) {
    finalTitle.push(isLog ? `${specifyStr.join('的')}` : `指定周：${specifyStr.join('的')}`);
  }
  if (workStr.length) {
    finalTitle.push(`${workStr.join('')}`);
  }
  if (lastStr.length) {
    finalTitle.push(`${lastStr[lastStr.length - 1]}`);
  }
  if (appointStr.length) {
    finalTitle.push(isLog ? `${appointStr.join('的')}` : `指定时间：${appointStr.join('的')}`);
  }
  return isLog ? finalTitle.join('') : finalTitle;
};